<div id='container'>
    <div class='wrap'>
        <input 
        ejs-rating id="rating"
        [value]="value" 
        (valueChanged)="onRatingChange($event)"
        min="0" 
        max="{{ maxRating }}" 
        class="star-rating-input"
        showLabel="true" 
        labelPosition="Left"
        itemsCount="{{itemsCount}}"
        [tooltipTemplate]="tooltipTemplate"
        />
        <ng-template #tooltipTemplate let-data="">
            <div [ngSwitch]="data.value">
                <ng-container *ngFor="let tag of lstTags, let i = index">
                    <span *ngSwitchCase="i+1" >{{tag}}</span>
                </ng-container>
            </div>
          </ng-template>
    </div>
</div>
  